import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const LanguageContext = createContext();

export const translations = {
  en: {
    // Navbar
    home: "Home",
    products: "Products",
    shopNow: "Shop Now",
    
    // Hero
    officialPartner: "Official LifeWave Partner",
    heroTitle: "Discover LifeWave Phototherapy",
    heroDescription: "Experience the power of light therapy patches. Enhance your energy, improve sleep, and support your body's natural wellness.",
    shopOnLifeWave: "Shop on LifeWave",
    browseProducts: "Browse Products",
    
    // Features
    whyLifeWave: "Why LifeWave",
    futureWellness: "The Future of Natural Wellness",
    revolutionaryTech: "Revolutionary Technology",
    revolutionaryDesc: "Phototherapy patches that activate your body's natural healing abilities.",
    wellnessBenefits: "Wellness Benefits",
    wellnessDesc: "Support energy, sleep, recovery, and overall vitality naturally.",
    noDrugs: "No Drugs or Chemicals",
    noDrugsDesc: "Safe, non-transdermal patches using light therapy.",
    scienceBacked: "Science-Backed",
    scienceDesc: "Over 80+ clinical studies supporting our technology.",
    
    // Products
    ourProducts: "Our Products",
    featuredPatches: "Featured Patches",
    viewAll: "View All",
    pricingNote: "Pricing Note",
    pricingDisclaimer: "Prices shown exclude VAT and shipping. Final prices calculated at checkout based on your location.",
    priceExcl: "excl. VAT & shipping",
    buyNow: "Buy Now",
    
    // Product Detail
    backToProducts: "Back to Products",
    benefits: "Benefits",
    howToUse: "How to Use",
    ingredients: "What's Included",
    buyOnLifeWave: "Buy on Official LifeWave Shop",
    purchaseDirectly: "Purchase directly from my official LifeWave store",
    contactMe: "Contact Me",
    questionsWhatsApp: "Have questions? Contact me on WhatsApp",
    
    // CTA
    readyExperience: "Ready to Experience LifeWave?",
    ctaDescription: "Discover the benefits of phototherapy patches. Shop directly on my official LifeWave store for authentic products and personal support.",
    shopMyStore: "Shop on My LifeWave Store",
    secureCheckout: "Secure checkout on the official LifeWave website",
    
    // Footer
    footerDescription: "Discover the power of LifeWave phototherapy patches. Enhance your wellness naturally with science-backed technology.",
    visitShop: "Visit My Official LifeWave Shop",
    quickLinks: "Quick Links",
    footerDisclaimer: "All prices shown exclude VAT and shipping costs. Different taxes apply depending on your state/country. Final prices will be calculated at checkout on the official LifeWave website.",
    
    // Products Page
    discover: "Discover",
    lifewaveProducts: "LifeWave Products",
    productsPageDesc: "Explore our revolutionary phototherapy patches designed to enhance your wellness and vitality. Click on any product to learn more.",
    importantPricing: "Important Pricing Information",
    priceDisclaimer1: "All prices shown are excluding VAT and shipping costs",
    priceDisclaimer2: "Different taxes apply depending on your state/country",
    priceDisclaimer3: "Final price will be calculated at checkout on the official LifeWave store",
    searchProducts: "Search products...",
    all: "All",
    showing: "Showing",
    of: "of",
    productsText: "products",
    shopAllProducts: "Shop All Products on LifeWave",
    purchaseSecurely: "Purchase securely on the official LifeWave website",
    noProductsFound: "No products found matching your criteria.",
    clearFilters: "Clear Filters",
  },
  ro: {
    // Navbar
    home: "Acasă",
    products: "Produse",
    shopNow: "Cumpără Acum",
    
    // Hero
    officialPartner: "Partener Oficial LifeWave",
    heroTitle: "Descoperă Fototerapia LifeWave",
    heroDescription: "Experimentează puterea plasturilor cu terapie prin lumină. Îmbunătățește-ți energia, somnul și susține bunăstarea naturală a corpului tău.",
    shopOnLifeWave: "Cumpără pe LifeWave",
    browseProducts: "Vezi Produsele",
    
    // Features
    whyLifeWave: "De ce LifeWave",
    futureWellness: "Viitorul Bunăstării Naturale",
    revolutionaryTech: "Tehnologie Revoluționară",
    revolutionaryDesc: "Plasturi de fototerapie care activează abilitățile naturale de vindecare ale corpului.",
    wellnessBenefits: "Beneficii pentru Sănătate",
    wellnessDesc: "Susține energia, somnul, recuperarea și vitalitatea în mod natural.",
    noDrugs: "Fără Medicamente sau Chimicale",
    noDrugsDesc: "Plasturi siguri, non-transdermali, folosind terapia prin lumină.",
    scienceBacked: "Susținut Științific",
    scienceDesc: "Peste 80 de studii clinice care susțin tehnologia noastră.",
    
    // Products
    ourProducts: "Produsele Noastre",
    featuredPatches: "Plasturi Populari",
    viewAll: "Vezi Toate",
    pricingNote: "Notă despre Prețuri",
    pricingDisclaimer: "Prețurile afișate nu includ TVA și livrarea. Prețurile finale se calculează la checkout în funcție de locația ta.",
    priceExcl: "fără TVA și livrare",
    buyNow: "Cumpără",
    
    // Product Detail
    backToProducts: "Înapoi la Produse",
    benefits: "Beneficii",
    howToUse: "Cum se Folosește",
    ingredients: "Ce Include",
    buyOnLifeWave: "Cumpără de pe Magazinul Oficial LifeWave",
    purchaseDirectly: "Cumpără direct din magazinul meu oficial LifeWave",
    contactMe: "Contactează-mă",
    questionsWhatsApp: "Ai întrebări? Contactează-mă pe WhatsApp",
    
    // CTA
    readyExperience: "Pregătit să Experimentezi LifeWave?",
    ctaDescription: "Descoperă beneficiile plasturilor de fototerapie. Cumpără direct din magazinul meu oficial LifeWave pentru produse autentice și suport personal.",
    shopMyStore: "Cumpără din Magazinul Meu LifeWave",
    secureCheckout: "Checkout securizat pe site-ul oficial LifeWave",
    
    // Footer
    footerDescription: "Descoperă puterea plasturilor de fototerapie LifeWave. Îmbunătățește-ți bunăstarea natural cu tehnologie susținută științific.",
    visitShop: "Vizitează Magazinul Meu Oficial LifeWave",
    quickLinks: "Link-uri Rapide",
    footerDisclaimer: "Toate prețurile afișate nu includ TVA și costurile de livrare. Se aplică taxe diferite în funcție de țara/statul tău. Prețurile finale vor fi calculate la checkout pe site-ul oficial LifeWave.",
    
    // Products Page
    discover: "Descoperă",
    lifewaveProducts: "Produse LifeWave",
    productsPageDesc: "Explorează plasturii noștri revoluționari de fototerapie concepuți pentru a-ți îmbunătăți bunăstarea și vitalitatea. Click pe orice produs pentru a afla mai multe.",
    importantPricing: "Informații Importante despre Prețuri",
    priceDisclaimer1: "Toate prețurile afișate nu includ TVA și costurile de livrare",
    priceDisclaimer2: "Se aplică taxe diferite în funcție de statul/țara ta",
    priceDisclaimer3: "Prețul final va fi calculat la checkout pe magazinul oficial LifeWave",
    searchProducts: "Caută produse...",
    all: "Toate",
    showing: "Se afișează",
    of: "din",
    productsText: "produse",
    shopAllProducts: "Cumpără Toate Produsele pe LifeWave",
    purchaseSecurely: "Cumpără în siguranță pe site-ul oficial LifeWave",
    noProductsFound: "Nu s-au găsit produse care să corespundă criteriilor tale.",
    clearFilters: "Șterge Filtrele",
  },
  de: {
    // Navbar
    home: "Startseite",
    products: "Produkte",
    shopNow: "Jetzt Kaufen",
    
    // Hero
    officialPartner: "Offizieller LifeWave Partner",
    heroTitle: "Entdecke LifeWave Phototherapie",
    heroDescription: "Erlebe die Kraft der Lichttherapie-Pflaster. Verbessere deine Energie, deinen Schlaf und unterstütze das natürliche Wohlbefinden deines Körpers.",
    shopOnLifeWave: "Bei LifeWave kaufen",
    browseProducts: "Produkte durchsuchen",
    
    // Features
    whyLifeWave: "Warum LifeWave",
    futureWellness: "Die Zukunft des natürlichen Wohlbefindens",
    revolutionaryTech: "Revolutionäre Technologie",
    revolutionaryDesc: "Phototherapie-Pflaster, die die natürlichen Heilungsfähigkeiten des Körpers aktivieren.",
    wellnessBenefits: "Wellness-Vorteile",
    wellnessDesc: "Unterstützt Energie, Schlaf, Erholung und Vitalität auf natürliche Weise.",
    noDrugs: "Keine Medikamente oder Chemikalien",
    noDrugsDesc: "Sichere, nicht-transdermale Pflaster mit Lichttherapie.",
    scienceBacked: "Wissenschaftlich unterstützt",
    scienceDesc: "Über 80 klinische Studien unterstützen unsere Technologie.",
    
    // Products
    ourProducts: "Unsere Produkte",
    featuredPatches: "Beliebte Pflaster",
    viewAll: "Alle ansehen",
    pricingNote: "Preishinweis",
    pricingDisclaimer: "Die angezeigten Preise verstehen sich ohne MwSt. und Versand. Endpreise werden beim Checkout basierend auf deinem Standort berechnet.",
    priceExcl: "ohne MwSt. & Versand",
    buyNow: "Kaufen",
    
    // Product Detail
    backToProducts: "Zurück zu Produkten",
    benefits: "Vorteile",
    howToUse: "Anwendung",
    ingredients: "Was enthalten ist",
    buyOnLifeWave: "Im offiziellen LifeWave Shop kaufen",
    purchaseDirectly: "Kaufe direkt in meinem offiziellen LifeWave Shop",
    contactMe: "Kontaktiere mich",
    questionsWhatsApp: "Hast du Fragen? Kontaktiere mich auf WhatsApp",
    
    // CTA
    readyExperience: "Bereit LifeWave zu erleben?",
    ctaDescription: "Entdecke die Vorteile von Phototherapie-Pflastern. Kaufe direkt in meinem offiziellen LifeWave Shop für authentische Produkte und persönliche Unterstützung.",
    shopMyStore: "In meinem LifeWave Shop kaufen",
    secureCheckout: "Sicherer Checkout auf der offiziellen LifeWave Website",
    
    // Footer
    footerDescription: "Entdecke die Kraft der LifeWave Phototherapie-Pflaster. Verbessere dein Wohlbefinden natürlich mit wissenschaftlich unterstützter Technologie.",
    visitShop: "Besuche meinen offiziellen LifeWave Shop",
    quickLinks: "Schnelllinks",
    footerDisclaimer: "Alle angezeigten Preise verstehen sich ohne MwSt. und Versandkosten. Je nach Land/Bundesland gelten unterschiedliche Steuern. Die Endpreise werden beim Checkout auf der offiziellen LifeWave Website berechnet.",
    
    // Products Page
    discover: "Entdecke",
    lifewaveProducts: "LifeWave Produkte",
    productsPageDesc: "Erkunde unsere revolutionären Phototherapie-Pflaster, die entwickelt wurden, um dein Wohlbefinden und deine Vitalität zu verbessern. Klicke auf ein Produkt, um mehr zu erfahren.",
    importantPricing: "Wichtige Preisinformationen",
    priceDisclaimer1: "Alle angezeigten Preise verstehen sich ohne MwSt. und Versandkosten",
    priceDisclaimer2: "Je nach Land/Bundesland gelten unterschiedliche Steuern",
    priceDisclaimer3: "Der Endpreis wird beim Checkout im offiziellen LifeWave Shop berechnet",
    searchProducts: "Produkte suchen...",
    all: "Alle",
    showing: "Zeige",
    of: "von",
    productsText: "Produkte",
    shopAllProducts: "Alle Produkte bei LifeWave kaufen",
    purchaseSecurely: "Sicher auf der offiziellen LifeWave Website kaufen",
    noProductsFound: "Keine Produkte gefunden, die deinen Kriterien entsprechen.",
    clearFilters: "Filter löschen",
  }
};

// Translation cache for dynamic content
const translationCache = {};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('language');
    return saved || 'ro';
  });

  useEffect(() => {
    localStorage.setItem('language', language);
  }, [language]);

  const t = (key) => {
    return translations[language]?.[key] || translations['en'][key] || key;
  };

  // AI Translation function for dynamic content
  const translateContent = useCallback(async (text, contentType = 'general', contentId = null) => {
    // If language is Romanian, return original (assuming content is in Romanian)
    if (language === 'ro' || !text) {
      return text;
    }

    // Check cache first
    const cacheKey = `${contentId || text.substring(0, 50)}_${language}`;
    if (translationCache[cacheKey]) {
      return translationCache[cacheKey];
    }

    try {
      const response = await axios.post(`${API_URL}/api/translate`, {
        text,
        target_language: language,
        content_type: contentType,
        content_id: contentId
      });
      
      const translatedText = response.data.translated_text;
      translationCache[cacheKey] = translatedText;
      return translatedText;
    } catch (error) {
      console.error('Translation error:', error);
      return text; // Fallback to original
    }
  }, [language]);

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t, translateContent }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
